import React from 'react';
import TextContainer from '../TextContainer';
import { withStyles, Typography, Link } from '@material-ui/core';
import styles from './Download.css';

function Download(props) {

    const {classes} = props;

    return (
        <div className={classes.download}>
            <TextContainer>
                <Typography variant="h5">Download</Typography>
                <br></br>
                <Typography variant="body1" component={'span'}>

                This software is open source and freely available for download.
                <ul>
                    <li>Locally installable version: <Link href="https://github.com/spreka/biomagdsb">https://github.com/spreka/biomagdsb</Link></li>
                    <li>CellProfiler plugin: <Link href="https://github.com/CellProfiler/CellProfiler-plugins/blob/master/nucleaizer.py">https://github.com/CellProfiler/CellProfiler-plugins/blob/master/nucleaizer.py</Link></li>
                </ul>
                </Typography>
            </TextContainer>
        </div>
    );
}

export default withStyles(styles, {withTheme: true})(Download);
